// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"browse-genres_mainHeading_iZ0Zi"};